import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Card } from "@mui/material";
import SideNav from "../../../components/sideNav";
import UserTable from "./UserTable";
import AllUserDetails from "./AllUserDetails";
import ParentWrapper from "../../../components/ParentWrapper";
import Header from "../../../components/header";

function SuperAdminUserManagement() {
  return (
    // <Box>
    //   <Box>
    //     {/* <SideNav /> */}
    //     <Box
    //       sx={{
    //         ml: {
    //           xs: "0px",
    //           md: "230px",
    //         },
    //         p:3
    //       }}
    //     >
    //       <Box
    //         sx={{
    //           mb: 2,
    //           mt: {
    //             xs: 0,
    //             md: 1,
    //           },
    //           p: 3,
    //         }}
    //       >
    //         {/* Dashboard Title */}
    //         <Typography
    //           variant="body2"
    //           style={{
    //             color: "grey",
    //           }}
    //         >
    //           {"Home > User Management"}
    //         </Typography>
    //         <UserTable />
    //         <AllUserDetails />
    //       </Box>
    //     </Box>
    //   </Box>
    // </Box>
    <ParentWrapper>
       <Box
            sx={{
              mb: 2,
              mt: {
                xs: 0,
                md: 1,
              },
              p: 3,
            }}
          >
            {/* Dashboard Title */}
            {/* <Typography
              variant="body2"
              style={{
                color: "grey",
              }}
            >
              {"Home > User Management"}
            </Typography> */}
             <Header title={"Home > User Management"}  />
            <UserTable />
            <AllUserDetails />
          </Box>
    </ParentWrapper>
  );
}

export default SuperAdminUserManagement;
